import VerifyEmail from './VerifyEmail';

export { VerifyEmail };
export default VerifyEmail;
